import { Requests } from '@erecruit/types';
import { getResourceApi } from '@erecruit/modules';
import { put, takeLatest } from 'redux-saga/effects';
import { PayloadAction } from 'redux-starter-kit';
import { SubmitProblemPayloadProps } from '../types';
import { submitProblemFail, submitProblemSuccess } from './reducer';
import { withStatusInfo } from '../../ActionStatus';

function* submitProblemErrorHandler(e: Error) {
  console.error(e);
  yield put(submitProblemFail(e.message));
}

function* submitProblem(data: PayloadAction<SubmitProblemPayloadProps>) {
  const props = data.payload;
  const response = yield getResourceApi().createMutationRequest(
    new Requests.SubmitProblemRequest({
      subject: props.subject,
      body: props.description,
      attachments: props.attachments,
    }),
  );

  yield put(submitProblemSuccess(response));
}

function* watchForSubmitProblem() {
  yield takeLatest(
    'problemReport/submitProblem',
    withStatusInfo({
      successGeneratorFn: submitProblem,
      errorGeneratorFn: submitProblemErrorHandler,
      getSuccessMessage: () => ({
        id: messageIds.vms.reportProblem.successInfo,
      }),
      getLoadingMessage: () => ({
        id: messageIds.vms.reportProblem.progressInfo,
      }),
      getHeader: () => ({
        title: {
          id: messageIds.vms.reportProblem.submittingHeaderText,
        },
      }),
      autocloseMs: 2000,
    }),
  );
}
export default [watchForSubmitProblem()];
